import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ShopifyObjectDataset } from 'app/model/dataset/shopify.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'ShopifySource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(ShopifyObjectDataset) }
})
export class ShopifyCopySource extends TabularCopySource {
}
